import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { telemetry } from '../../../services/backend';
import {
  authenticationCheck,
  UNAUTHENTICATED_URL,
} from '../../../services/route/permissions';
import { selectCurrentMember } from '../../../services/store/modules/backend-service';

const AuthCheck: FC<{
  authentication: string | number;
  redirectUrl?: string;
}> = ({ authentication, redirectUrl, children }) => {
  const member = useSelector(selectCurrentMember);

  if (authenticationCheck(authentication, member)) {
    telemetry(telemetry.DEBUG, `[AuthCheck] Rendering supplied component.`);

    return <>{children}</>;
  }

  telemetry(
    telemetry.INFO,
    `LOGIN_REDIRECT: Authentication check failed, redirecting to ${redirectUrl}`,
  );
  return <Redirect to={redirectUrl || ''} />;
};

AuthCheck.defaultProps = {
  redirectUrl: UNAUTHENTICATED_URL,
};

export default AuthCheck;
